// extracted by mini-css-extract-plugin
module.exports = {"wrap":"Wp-z","subtitle":"Xp-z","contentWrap":"Yp-z","imgWrap":"Zp-z","heading":"_p-z","copy":"aq-z"};